module.exports = __webpack_public_path__ + "img/drawer_robot_active.3451803d.svg";